/**
 * Google Analytics Configuration
 * 
 * Set REACT_APP_GA_MEASUREMENT_ID environment variable with your Google Analytics Measurement ID
 * Example: REACT_APP_GA_MEASUREMENT_ID=G-XXXXXXXXXX
 */

export const ANALYTICS_CONFIG = {
  measurementId: process.env.REACT_APP_GA_MEASUREMENT_ID,
  enabled: !!process.env.REACT_APP_GA_MEASUREMENT_ID,
  // Development environment uses test mode (events are tracked but not included in reports)
  isDevelopment: process.env.NODE_ENV === 'development',
};

export const isAnalyticsEnabled = () => {
  return ANALYTICS_CONFIG.enabled;
};
